import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTabs,{attrs:{"centered":""},model:{value:(_vm.tab_ativo),callback:function ($$v) {_vm.tab_ativo=$$v},expression:"tab_ativo"}},[_c(VTab,[_vm._v("Eventos")])],1),_c(VTabsItems,{model:{value:(_vm.tab_ativo),callback:function ($$v) {_vm.tab_ativo=$$v},expression:"tab_ativo"}},[_c(VTabItem,[_c('EventoSazonal')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }